import React, { useState } from 'react'
import MuiAlert from '@material-ui/lab/Alert';
import { emptyMessagePenyimpanan, penyimpananDeleteToAPI } from '../../../config/redux/action';
import { Button, Dialog, DialogContent, DialogTitle, Divider, makeStyles, Snackbar, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
const DeletePenyimpanan = ({HandleClickCloseDeleteDialog,tempID,idform,tempKeterangan,...rest}) => {
    const useStyle = makeStyles((theme)=>({
        titleDialog:{
            width:'400px',
            [theme.breakpoints.down('sm')]:{
                width:'250px',
            },
            textAlign:'center',
        },
        contentDelete:{
            padding:'10px'
        },
        button:{
            display:'flex',
            justifyContent:'space-between',
            paddingBottom:"5px",
        },
        textFiled:{
            width:'100%',
            paddingBottom:"7px",
        },
    }));
    const classes=useStyle();
    const {data} = useSelector(state=>state.loginReducers);
    const {messagePenyimpanan,isLoadingPenyimpanan} = useSelector(state=>state.penyimpananReducers);
    const dispatch = useDispatch();
    const [token,setToken] = useState(data.token);
    if(token ===''){
        setToken(Cookies.get('u_tkn'));
    }
    const [openSnackbar,setOpenSnackbar] = useState(false);
    const handleCloseSnackBar = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpenSnackbar(false);
        setTimeout(()=>{
            dispatch(emptyMessagePenyimpanan(""));
        },100)
      };
    const onSubmit=()=>{
        dispatch(penyimpananDeleteToAPI(tempID,token,setOpenSnackbar,HandleClickCloseDeleteDialog));
    }
    return (
        <div>
            <Dialog open={false} {...rest}>
            <DialogTitle className={classes.titleDialog} id={idform}>Hapus Data Penyimpanan</DialogTitle>
                <Divider/>
                <DialogContent>
                    <div className={classes.contentDelete}>
                    <Typography align='center'>Apakah anda yakin akan menghapus data penyimpanan</Typography>
                    <Typography align='center'>({tempID}){tempKeterangan}?</Typography>
                    </div>
                <div className={classes.button}>
                <Button 
                id='hapus'
                name='hapus'
                variant="contained" 
                color="primary" onClick={onSubmit} 
                disabled={isLoadingPenyimpanan}>Hapus</Button>
                <Button variant="contained" color="secondary" onClick={HandleClickCloseDeleteDialog}
                >Keluar</Button>
                </div>
                </DialogContent>
            </Dialog>
            <Snackbar open={openSnackbar} autoHideDuration={2000} onClose={handleCloseSnackBar}>
                <Alert 
                onClose={handleCloseSnackBar} 
                severity={messagePenyimpanan === 'Data penyimpanan berhasil dihapus' ? "success" : "error"} 
                onClick={HandleClickCloseDeleteDialog}>{messagePenyimpanan}</Alert>
            </Snackbar>
        </div>
    )
}

export default DeletePenyimpanan
